<div class="table--grid" *ngIf="loadedData">
    <div class="table--grid__header">
        {{ 'Diagnosis' | translate  }}
    </div>
    <div class="table--grid__body">
        <div class="row table--grid__body--header">
            <div class="col-xs-11">
                <div class="row">
                    <div *ngFor="let column of patientDiagnosisTableColumns" class="{{ column[2] }}">
                        {{ column[1] | translate }}
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngFor="let proposal of proposals">
            <div class="row" [class.br-b--n]="proposal.criterias.length && isCriteriaExpanded[proposal.diagnoses_id]">
                <div class="col-xs-11">
                    <div class="row">
                        <div *ngFor="let column of patientDiagnosisTableColumns" class="{{ column[2] }}">
                            <div *ngIf="column[0] === 'code'" (click)="toggleCollapse(proposal)">
                                <span class="icd-code__fa" *ngIf="isCriteriaExpanded[proposal.diagnoses_id] && proposal.criterias.length !== 0">
                                    <i class="fal fa-angle-up"></i>
                                </span>
                                    <span class="icd-code__fa" *ngIf="!isCriteriaExpanded[proposal.diagnoses_id] && proposal.criterias.length !== 0">
                                    <i class="fal fa-angle-down"></i>
                                </span>
                                    <span>
                                    {{ proposal['diagnoses'][column[0]] }}
                                </span>
                            </div>
                            <ng-container *ngIf="column[0] === 'name'">
                                <span>
                                    {{ proposal['diagnoses']['name_' + translate.currentLang] }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column[0] === 'creator'">
                                <span>
                                    {{ proposal['diagnoses'][column[0]] }}, {{ proposal['diagnoses']['clinic'] }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column[0] === 'created_at'">
                                <span>
                                    {{ proposal['diagnoses']['pivot'][column[0]] | datex:'DD.MM.YYYY' }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="column[0] === 'related_domain'">
                                <div class="related-domain" *ngFor="let domain of proposal[column[0]]">
                                    {{ domain['name_' + translate.currentLang] }} <span class="separator"> </span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="column[0] === 'percentage'">
                                <div class="progress-wrapper progress-1">
                                    <span class="percentage percentage--from hidden">{{ld.parseInt(proposal.percentage.from)}}%</span>
                                    <span class="percentage hidden" *ngIf="proposal.percentage.from != proposal.percentage.to"> - {{ld.parseInt(proposal.percentage.to)}}%</span>
                                    <span class="progress-bar">
                                        <span class="progress-bar__percentage" [style.width]="(100 - ld.parseInt(proposal.percentage.from))*0.8 + 'px'"></span>
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-xs-1 align-self-start" *ngIf="
                    lastestQuestionnaire && lastestQuestionnaire['archived'] && !lastestQuestionnaire['di_questionnaire']['archived'] && lastestQuestionnaire['di_questionnaire']['step'] >= 3">
                    <span tooltip="{{'Edit' | translate}}" placement="bottom" class="action__icon" *ngIf="!viewOnly" (click)="edit(proposal)">
                        <i class="action__icon--fa edit"></i>
                    </span>
                    <span *ngIf="!viewOnly"
                        tooltip="{{'Delete' | translate}}" 
                        placement="bottom" class="action__icon" 
                        (click)="confirmToDelete(proposal);">
                        <i class="action__icon--fa delete"></i>
                    </span>
                </div>
            </div>

            <div class="row criteria" *ngIf="proposal.criterias.length && isCriteriaExpanded[proposal.diagnoses_id]">
                <div class="col-xs-12 d-flex mb-1" *ngIf="proposal['diagnoses']['category'] || proposal['diagnoses']['subcategory']">
                    <div *ngIf="proposal['diagnoses']['category'] && proposal['diagnoses']['categoryLastChild']" class="categories__primary">{{ proposal['diagnoses']['category'].code.length === 2 ? proposal['diagnoses']['category'].code + '0' : proposal['diagnoses']['category'].code }}-{{ proposal['diagnoses']['categoryLastChild'] }} - {{ translate.currentLang == 'de_CH' ? proposal['diagnoses']['category'].name : proposal['diagnoses']['category'].name_en }}</div>
                    <div class="categories__secondary">{{ proposal['diagnoses']['subcategory']?.code }} - {{ translate.currentLang == 'de_CH' ? proposal['diagnoses']['subcategory']?.name : proposal['diagnoses']['subcategory']?.name_en }}</div>
                </div>
                <div class="col-xs-12 d-flex">
                    <strong>{{ 'Criteria' | translate }}</strong>
                </div>
                <div class="col-xs-12 criteria__item">
                    <div *ngFor="let criteria of proposal.criterias" class="row">
                        <div class="col-xs-1 criteria__item__letter">
                            <span>{{criteria.criteria_letter}}.</span>
                        </div>
                        <div class="col-xs-11 criteria__item__shorttext">
                            <span>{{criteria['criteria_short_text_' + translate.currentLang]}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="proposals.length === 0">
            <div class="row">
                <div class="col-xs-11">
                    <div class="row">
                        <div class="col-xs-12 no-item">
                            <span>{{ 'No Diagnosis Yet' | translate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="row" 
            *ngIf="items && items.length > 0 && 
            lastestQuestionnaire && lastestQuestionnaire['archived'] && !lastestQuestionnaire['di_questionnaire']['archived'] && lastestQuestionnaire['di_questionnaire']['step'] >= 3">
            <div class="col-xs-1 offset-xs-11">
                <button (click)="edit()" class="btn btn-add-diagnosis btn-icon btn-icon--left pull-right" type="button" *ngIf="!viewOnly">
                    <i class="fal fa-plus"></i>
                    {{ 'Add Diagnosis' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

<dialog-component #dialog></dialog-component>